/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <Card>
    <div v-if="data == null" class="circular-progress-container">
    <v-progress-circular :value="80" indeterminate color="deep-orange lighten-2"></v-progress-circular>
    </div>
    <v-data-table class="primary" :headers="headers" :items="data" hide-actions>
      <template slot="items" slot-scope="myprops">
        <tr class="primary">
        <td v-for="header in headers" 
        :style="header.value == 'breaker_name' ? ({color: myprops.item.breaker_off === 1 || myprops.item.breaker_trip ===  1 ? 'red' : 'green'}) : ''"
        :key="header.value" 
        :class="enableAlert ? (myprops.item[header.value] ? '' : 'alert') :'' " class="text-xs-left"
        >{{ myprops.item[header.value] !== null ? myprops.item[header.value] :
          errorMessage }}</td>
          </tr>
      </template>
    </v-data-table>
  </Card>
</template>

<script>
export default {
  props: ["headers", "data", "title", "toolbar", "enableAlert", "errorMessage"]
};
</script>

<style scope>
table.v-table tbody td,
table.v-table tbody th {
  height: 20px;
}

table.v-table thead tr {
    height: 36px;
}

.alert {
  /* color:white; */
  color:red;
  /* background-color: red */
  
}

table.v-table tbody td:not(:nth-child(1)),
table.v-table thead th:not(:nth-child(1)) {
  padding: 0 6px;
}


</style>

<style scoped>
.circular-progress-container {
  margin-top: 0;
  text-align: center;
  padding: 1rem;
}

</style>